import { wrapGlobalApp } from "./src/AppWrapper";

/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.org/docs/browser-apis/
 */

export const wrapRootElement = wrapGlobalApp;
